import fetchApi, { isFetchError } from "@lib/api-fetcher/fetchApi";
import { API_ROUTES } from "@utils/constants";
import { reportError } from "@utils/errorReporting";

import validateOffersResponse from "../models/offers";
import { TOffersParams, TOffersResult } from "../types";
import mapOffersErrorsToErrorMessages from "../utils/mapOffersErrorsToErrorMessages";
import mapOffersResponse from "../utils/mapOffersResponse";

const mapOffersParamsToRequestParams = (params: TOffersParams): any => ({
  countryFrom: params.countryFrom,
  countryTo: params.countryTo,
  dimension: params.packageSizeTitle,
  serviceType: params.deliveryMethod,
  ...(params.promoCode && {
    coupon: {
      couponCode: params.promoCode,
      phone: params?.senderPhoneNumber,
      email: params?.senderEmail,
      priceGroupId: params?.offerGroupId,
      // eslint-disable-next-line @typescript-eslint/naming-convention
      delivery_type: params?.deliveryMethod,
    },
  }),
  ...(params.senderZipCode && { postalCodeFrom: params.senderZipCode }),
  ...(params.receiverZipCode && { postalCodeTo: params.receiverZipCode }),
  ...(params.affiliateId && { affiliateGuid: params.affiliateId }),
  ...(params.shipmentId && { shipmentId: params.shipmentId }),
  ...(params.useCr && { useCr: params.useCr }),
});

const loadOffers = async (offersParams: TOffersParams, locale?: string, hostname?: string): Promise<TOffersResult> => {
  if (!offersParams.packageSizeTitle) {
    return { isSuccess: false };
  }
  try {
    const response = await fetchApi({
      url: API_ROUTES.OFFERS,
      method: "POST",
      data: mapOffersParamsToRequestParams(offersParams),
      locale,
      hostname,
    });
    const offersResponse = validateOffersResponse(response.data);
    return mapOffersResponse(offersResponse, offersParams);
  } catch (err) {
    if (isFetchError(err) && err.response?.status === 422) {
      const errors = mapOffersErrorsToErrorMessages(err);
      return { isSuccess: false, ...errors };
    }
    reportError(err, { module: "order" });
    return { isSuccess: false };
  }
};
export default loadOffers;
